import { createSlice } from "@reduxjs/toolkit";

// Helper to safely parse JSON
const safeParse = (key) => {
  const item = localStorage.getItem(key);
  if (!item || item === "undefined" || item === "null") return null;
  try {
    return JSON.parse(item);
  } catch (e) {
    return null;
  }
};

// Initial state logic
const storedToken = localStorage.getItem("token");
const storedUserInfo = safeParse("userInfo");

// Only consider authenticated if BOTH token and userInfo exist
const isValidSession = !!(storedToken && storedUserInfo);

const initialState = {
  userInfo: isValidSession ? storedUserInfo : null,
  token: isValidSession ? storedToken : null,
  isAuthenticated: isValidSession,
  // UI State for Auth Modal
  isAuthModalOpen: false,
  authModalMode: 'login', // 'login' | 'signup' | 'forgot-password'
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { userInfo, user, token } = action.payload;
      const finalUser = user || userInfo;
      
      state.userInfo = finalUser;
      state.token = token;
      state.isAuthenticated = true;
      
      if (finalUser) {
        localStorage.setItem("userInfo", JSON.stringify(finalUser));
      } else {
        localStorage.removeItem("userInfo");
      }
      
      if (token) {
        localStorage.setItem("token", token);
      }
      
      // Close modal on successful login
      state.isAuthModalOpen = false;
    },
    logout: (state) => {
      state.userInfo = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
    },
    // UI Reducers
    openAuthModal: (state, action) => {
      state.isAuthModalOpen = true;
      state.authModalMode = action.payload || 'login';
    },
    closeAuthModal: (state) => {
      state.isAuthModalOpen = false;
    },
    setAuthModalMode: (state, action) => {
      state.authModalMode = action.payload;
    },
    clearError: (state) => {
       // Placeholder
    }
  },
});

export const { 
  setCredentials, 
  logout, 
  clearError,
  openAuthModal,
  closeAuthModal,
  setAuthModalMode
} = authSlice.actions;

// Selectors
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated || !!state.auth.token;
export const selectAuth = (state) => state.auth;
export const selectUser = (state) => state.auth.userInfo;
export const selectIsAuthModalOpen = (state) => state.auth.isAuthModalOpen;
export const selectAuthModalMode = (state) => state.auth.authModalMode;

export default authSlice.reducer;
